import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileStickyBar from "../components/MobileStickyBar";
import Seo from "../components/Seo";
import { COMPANY } from "../lib/site";
import { useLang } from "../i18n/LanguageContext";

export default function Privacy() {
  const { t } = useLang();
  return (
    <div className="min-h-screen">
      <Seo title={`${t("privacy.title")} | ${COMPANY.name}`} description={t("privacy.intro")} path="/personvern" />
      <Header />
      <section className="section">
        <div className="container-page max-w-3xl">
          <span className="eyebrow">{t("privacy.eyebrow")}</span>
          <h1 className="mt-2 font-display text-4xl font-bold">{t("privacy.title")}</h1>
          <div className="dot-divider mt-4" />
          <div className="prose mt-6 max-w-none text-[#1C1F22] leading-relaxed space-y-4">
            <p>{COMPANY.name} {t("privacy.intro")}</p>
            <h2 className="font-display text-2xl font-bold mt-6">{t("privacy.what.title")}</h2>
            <p>{t("privacy.what.body")}</p>
            <h2 className="font-display text-2xl font-bold mt-6">{t("privacy.purpose.title")}</h2>
            <p>{t("privacy.purpose.body")}</p>
            <h2 className="font-display text-2xl font-bold mt-6">{t("privacy.retention.title")}</h2>
            <p>{t("privacy.retention.body")}</p>
            <h2 className="font-display text-2xl font-bold mt-6">{t("privacy.rights.title")}</h2>
            <p>{t("privacy.rights.body")} {COMPANY.email}.</p>
            <h2 className="font-display text-2xl font-bold mt-6">{t("privacy.security.title")}</h2>
            <p>{t("privacy.security.body")} {COMPANY.name}.</p>
          </div>
        </div>
      </section>
      <Footer /><MobileStickyBar />
    </div>
  );
}
